import React, { useEffect, useState } from "react"
import MetaTags from "react-meta-tags"
import { Container, UncontrolledTooltip } from "reactstrap"
import { useHistory } from "react-router"
import { connect } from "react-redux"
import { openWelcome } from "store/actions"
import { isMobile, isMobileOnly } from "react-device-detect"

const vidi = {
  position: "relative",
  height: "100%",
  width: "100vw",
  overflow: "hidden scroll",
  display: "none",
}

const Dashboard = props => {
  const { welcome, onOpenWelcome } = props
  const [newImgSrc, setNewImgSrc] = useState("")
  const [fixState,setFixState] = useState(false)
  const [isSmallScreen, setIsSmallScreen] = useState(false)
  const [showSkip, setShowSkip] = useState(false) // controls the delayed skip-button animation

  const videoSrc = isMobile
    ? "https://firebasestorage.googleapis.com/v0/b/assets-f1765.firebasestorage.app/o/Apple%20Virtual%20Platform%202026%2FWalkthrough.mp4?alt=media&token=f4296c83-289b-4e1d-82dd-b60b6c4374f3"
    : "https://firebasestorage.googleapis.com/v0/b/assets-f1765.firebasestorage.app/o/Apple%20Virtual%20Platform%202026%2FWalkthrough.mp4?alt=media&token=f4296c83-289b-4e1d-82dd-b60b6c4374f3"
  const imgSrc = isMobile
    ? "https://firebasestorage.googleapis.com/v0/b/assets-f1765.firebasestorage.app/o/Apple%20Virtual%20Platform%202026%2FClick%20to%20enter.png?alt=media&token=874ed4cb-ce56-447e-b4f1-38d2d371b65b"
    : "https://firebasestorage.googleapis.com/v0/b/assets-f1765.firebasestorage.app/o/Apple%20Virtual%20Platform%202026%2FClick%20to%20enter.png?alt=media&token=874ed4cb-ce56-447e-b4f1-38d2d371b65b"

  const history = useHistory()
  function tAdd() {
    const body = document.body
    body.classList.add("vertical-collpsed")
    body.classList.add("sidebar-enable")
  }

  useEffect(() => {
    const checkScreenSize = () => {
      if (window.innerWidth < 500) {
        window.location.reload();
        setIsSmallScreen(true) // was: document.getElementById("skip1").style.display = "none"
        setNewImgSrc(
          "https://firebasestorage.googleapis.com/v0/b/assets-f1765.firebasestorage.app/o/apple%20virtual%20platform%2FRotate%20Your%20Phone.gif?alt=media&token=797900cb-990e-466a-9182-c675914732ab"
        )
        setFixState(!fixState);

      }else{
        setIsSmallScreen(false) // was: document.getElementById("skip1").style.display = "block"

          setNewImgSrc(
            "https://firebasestorage.googleapis.com/v0/b/assets-f1765.firebasestorage.app/o/Apple%20Virtual%20Platform%202026%2FClick%20to%20enter.png?alt=media&token=874ed4cb-ce56-447e-b4f1-38d2d371b65b"
          )
          setFixState(!fixState);
        }
      }

    checkScreenSize()
    window.addEventListener("resize", checkScreenSize)

    return () => {
      window.removeEventListener("resize", checkScreenSize)
    }
  }, [])

  // Reveal the skip button 3 seconds after mount, with a fade/slide-in animation
  useEffect(() => {
    const timer = setTimeout(() => {
      setShowSkip(true)
    }, 3000)

    return () => clearTimeout(timer)
  }, [])

  const loader = document.querySelector(".loader")

  useEffect(() => {
    loader.classList.add("loader--hide")
  }, [])
  return (
    <React.Fragment>
      <div style={{ padding: 0 }} className="page-content">
        <MetaTags>
          <title>The Advocacy Live Stream</title>
        </MetaTags>

        <Container style={{ padding: 0 }} fluid>
          <img
            onClick={() => history.push("/page/lobby")}
            id="img-1"
            alt=""
            src={fixState?newImgSrc:imgSrc}
            width="100%"
            loading="lazy"
          />

          {/* <img
            src={imgSrc} // Default fallback image
            srcSet={`
    https://firebasestorage.googleapis.com/v0/b/assets-f1765.firebasestorage.app/o/apple%20virtual%20platform%2FRotate%20Your%20Phone.gif?alt=media&token=797900cb-990e-466a-9182-c675914732ab 500w,
    ${imgSrc} 501w
  `}
            sizes="(max-width: 500px) 100vw, 50vw"
            style={{
              top: "0%",
              width: "100%",
              position: "absolute",
              height: "100%",
              left: "0%",
              objectFit: "cover",
            }}
            loading="eager" 
          /> */}

          <div>
            {/* <UncontrolledTooltip target="skip1">Skip</UncontrolledTooltip> */}
            <div
              id="skip1"
              // onClick={() => { history.push("/page/lobby") }} //addedy
              onClick={() => {
                //change here for redirection after on click on skip
                history.push("/page/lobby")
              }}
              style={{
                padding: "0px 16px",       // was 16/20
                border: "none",
                borderRadius: "10px",
                background: "#1d1d1f",
                color: "#fff",
                fontSize: "0.85rem",        // was 1rem
                fontWeight: 500,
                gap: "8px",
                boxShadow: "0 4px 12px rgba(0,0,0,0.25)",

                cursor: "pointer",
                display: isSmallScreen ? "none" : "flex",
                justifyContent: "center",
                alignItems: "center",
                transform: showSkip ? "skew(0deg, 0deg) translateY(0px)" : "skew(0deg, 0deg) translateY(-12px)",
                boxShadow: "0 4px 12px rgba(0,0,0,0.25)",
                position: "absolute",
                width: "fit-content",
                top: "5%",
                right: "5%",
                zIndex: "3",
                opacity: showSkip ? 1 : 0, // fades in after the 3s delay
                transition: "opacity 0.6s ease, transform 0.6s ease", // animates the entrance
                pointerEvents: showSkip ? "auto" : "none",
              }}
            >
              <span
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                SKIP{" "}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  height="40px"
                  viewBox="0 -960 960 960"
                  width="30px"
                  fill="#fff"
                >
                  <path d="M521.33-480.67 328-674l47.33-47.33L616-480.67 375.33-240 328-287.33l193.33-193.34Z" />
                </svg>
              </span>
            </div>
          </div>
          <div>
            {/* <UncontrolledTooltip target="click2enter">
              Click to Enter
            </UncontrolledTooltip> */}

            <div
              id="click2enter"
              // onClick={() => { history.push("/page/lobby") }} //addedy
              onClick={() => {
                // onOpenWelcome();
                document.getElementById("vid-1").style.display = "block"
                document.getElementById("img-1").style.display = "none"
                document.getElementById("vid-1").play()
              }}
              style={{
                cursor: "pointer",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                transform: "skew(0deg, 0deg)",
                position: "absolute",
                width: "100%",
                height: "100%",
                top: "0%",
                left: "0%",
              }}
            ></div>
          </div>

          <video
            preload="auto"
            id="vid-1"
            src={videoSrc}
            style={vidi}
            autostart="false"
            onLoadStart={() => {
              tAdd()
            }}
            onEnded={() => {
              history.push("/page/lobby")
            }}
          ></video>
        </Container>
      </div>
    </React.Fragment>
  )
}

// export default Dashboard

const mapStateToProps = ({ agenda }) => ({
  welcome: agenda.welcome,
})

const mapDispatchToProps = dispatch => ({
  onOpenWelcome: () => dispatch(openWelcome()),
})

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard)